// components/Layout.js
import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../views/header';
import HeaderPartner from '../views/HeaderPartner';
import HeaderEmployee from '../views/HeaderEmployee';
import { UserContext } from './Context/userContext';

const Layout = ({ children }) => {
    const { userType } = useContext(UserContext);
    const location = useLocation();

    const isLoginPage = ['/login', '/activate', '/', '/delete-account'].includes(location.pathname);

    return (
        <div className="app-container">
            {/* Render only the Header logic if not on the login route */}
            {!isLoginPage && userType === 'ADMIN' && <Header />}
            {!isLoginPage && userType === 'PARTNER' && <HeaderPartner />}
            {!isLoginPage && userType === 'EMPLOYEE' && <HeaderEmployee />}
            <div className="content-container">
                {children}
            </div>
        </div>
    );
};

export default Layout;
